export type BottomDrawerState = {
  visible: boolean;
  component: any;
  componentProps: any;
  title: string;
  events?: { [k: string]: () => any };
};

const drawerMutations = {
  hide(state: BottomDrawerState) {
    state.visible = false;
  },
  showComponent(
    state: BottomDrawerState,
    payload: {
      component: any;
      props: any;
      title: string;
      events: { [k: string]: () => any };
    }
  ) {
    state.component = payload.component;
    state.componentProps = payload.props;
    state.title = payload.title;
    state.visible = true;
    state.events = payload.events;
  }
};

const state: BottomDrawerState = {
  title: '',
  visible: false,
  component: null,
  componentProps: {}
};

export default {
  namespaced: true,
  state: state,
  mutations: drawerMutations
};
